import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

export const BraintreeAutoSubmitButton = ({ onClick, isDisabled }) => {
  const [wasClicked, setWasClicked] = useState(false);
  useEffect(
    () => {
      if (!isDisabled && !wasClicked) {
        onClick();
        setWasClicked(true);
      }
    },
    [isDisabled],
  );

  return (
    <Button
      onClick={onClick}
      type="primary"
      disabled={isDisabled}
      size="large"
      style={{ borderRadius: '20px', visibility: 'hidden' }}
    >
      <FormattedMessage id="settingsModal.connectAndPay" />
    </Button>
  );
};
